/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderDevicePayByTrackRequestSchema = z.object({
	track_number: z.string().min(1),
});
